import { Avatar, makeStyles } from '@material-ui/core';
import React from 'react';

interface AssigneeAvatarProps {
  assignee: {
    email: string;
    name?: string;
    imageUrl?: string;
  };
}

const useStyles = makeStyles((theme) => ({
  small: {
    width: theme.spacing(3.5),
    height: theme.spacing(3.5),
    fontSize: '13px',
  },
}));

const AssigneeAvatar: React.FC<AssigneeAvatarProps> = ({
  assignee,
}) => {
  const classes = useStyles();
  // if (!assignee) return <Avatar />;
  return (
    <Avatar
      // note not sure if should be address or fullname
      // title={assignee && assignee.name}
      className={classes.small}
      src={(assignee && assignee.imageUrl) || undefined}
    >
      {(assignee && assignee.name && assignee.name[0]) || '?'}
    </Avatar>
  );
};

export default AssigneeAvatar;
